module.exports = __webpack_public_path__ + "media/tape-nav/community-icon-0031b4e2.svg";